import React from "react";

const Social = ()=>{
    return(
        <div className="home__social">
            <a href="mailto:vaahwan@gmail.com" className="home__social-icon" target="_blank">
                <i class='bx bx-mail-send' ></i>
            </a>
            <a href="https://github.com/Vaahwan" className="home__social-icon" target="_blank">
                <i class='bx bxl-github' ></i>
            </a>
            <a href="https://www.linkedin.com/in/aahwan-verma-aa3903241/" className="home__social-icon" target="_blank">
                <i class='bx bxl-linkedin' ></i>
            </a>
        </div>
    )
}

export default Social;
